// import axios from 'axios';

// const baseURI = 'http://localhost:8081';

const codeTableStoreModule = {
  // namespaced: false,

  state: {
    codeTableList: Array,
  },
  mutations: {
    'SET_STORE_CODE_TABLE_LIST' (state, codeTableList) {
      state.codeTableList = codeTableList;
    },
  },
  actions: {
    getCodeTableList: async ({commit}) => {
      // await axios.get(baseURI + "/company/list").then((response) => {
      //   console.log(response.data);
      //   commit('SET_STORE_MONITOR_LIST', response.data);
      // }).catch((ex) => {
      //   console.log(ex);
      // });

      let data = [
        {
          name: 'Container Type/Size Code',
          last_update: '2020-01-02 12:45:28',
          manage: 'manage',
        },
        {
          name: 'Package Type Code',
          last_update: '2020-01-02 12:46:28',
          manage: 'manage',
        },
        {
          name: 'Location Code',
          last_update: '2020-01-02 12:47:28',
          manage: 'manage',
        },
        {
          name: 'Country Code',
          last_update: '2020-01-02 12:48:28',
          manage: 'manage',
        },
        {
          name: 'Port Code',
          last_update: '2020-01-02 12:49:28',
          manage: 'manage',
        },
        {
          name: 'Container Type/Size Code2',
          last_update: '2020-01-02 12:50:28',
          manage: 'manage',
        },
        {
          name: 'Package Type Code2',
          last_update: '2020-01-02 12:51:28',
          manage: 'manage',
        },
        {
          name: 'Location Code2',
          last_update: '2020-01-02 12:52:28',
          manage: 'manage',
        },
        {
          name: 'Country Code2',
          last_update: '2020-01-02 12:53:28',
          manage: 'manage',
        },
        {
          name: 'Port Code2',
          last_update: '2020-01-02 12:54:28',
          manage: 'manage',
        },
      ];

      commit('SET_STORE_CODE_TABLE_LIST', data);
    },
  },
  getters: {
    codeTableList: state => state.codeTableList,
  },
};

export default codeTableStoreModule;